const mixins: any = {};

export default mixins;
